<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N2N72x/tc-custom/9781629987019.jpg?1706411586125" alt="This image is the cover for the book Fasting for Breakthrough and Deliverance"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fasting for Breakthrough and Deliverance
      </h1>
      <p class="bookDescription body article font2">
        <p>Matthew 17:21 tells us that there are some spirits in a person, region, or nation that cannot be overcome without fasting. Many believers struggle with certain limitations that they cannot seem to break through. A revelation of the power of fasting will result in victories that would not be ordinarily obtained. A life of consistent fasting will cause many victories to manifest. God’s will is for every believer to live a life of victory with nothing being impossible.<br/>  <br/><b>There is freedom from the torment of the enemy!</b><br/> Best-selling author and trusted teacher on deliverance, John Eckhardt reveals strongholds that can be broken including poverty, sickness, witchcraft, sexual impurity, pride, fear, confusion, and marital problems. Fasting will help readers to overcome these manifestations of oppression and break free from their limitations.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Eckhardt
      </h2>
      
      <p class="authorDescription body article"><B>Apostle John Eckhardt</B> is overseer of Crusaders Ministries, located in Chicago, Illinois. Gifted with a strong apostolic call, he has ministered throughout the United States and overseas in more than eighty nations. He is a sought-after international conference speaker and has authored more than twenty books, including <I>Prayers That Rout Demons</I>, <I>Prayers That Break Curses</I>, and <I>God Still Speaks</I>. Eckhardt resides in the Chicago area with his wife, Wanda.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Charisma Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5bd44808